import React from "react";
import Chip from "@material-ui/core/Chip";
import { makeStyles } from "@material-ui/core";
import {BUILDING_COLORS} from '../dam/constants'
import {A11yContext} from '../dam/A11yContext'

const useStyles = makeStyles(theme => ({
  root: {
    backgroundColor: ({ status, a11y }) =>
      a11y 
        ? BUILDING_COLORS.a11y[status]
        : BUILDING_COLORS.main[status]
  },
  label: {
    color: ({ status }) =>
      ["APPLIED", "APPROVED"].includes(status)
        ? theme.palette.grey100
        : theme.palette.grey800,
    fontWeight: "bold"
  }
}));

export default function StatusChip({ status }) {
  const {a11yMode} = React.useContext(A11yContext);
  const classes = useStyles({ status, a11y: a11yMode });
  return <Chip component="span" classes={classes} label={status} />;
};
